import Vue from "vue";
import Vuetify from "vuetify/lib";
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#26a69a",
        secondary: "#eafbf8",
        danger: "#ff5252",
        main: "#eceff1",
        light: "#f5f5f5",
        header: "#263238",
        headerBtns: "#cfd8dc"
      }
    }
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
});
